import { Component, OnInit } from '@angular/core';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {StorageService} from '../../../services/rest-api/storage.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  facultyData: any[] = [];

  constructor(private _info: InfoApiService,
              private storage: StorageService) {
  }

  ngOnInit(): void {
    const localFacultydata = this.storage.getData('facultyData');
    this.facultyData = localFacultydata ? JSON.parse(localFacultydata): [];
  }
}
